var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-create-area"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"account-create-content"},[_c('h2',[_vm._v("Apply for an account in minutes")]),_c('p',[_vm._v("Get your Vibion account today!")]),_c('a',{staticClass:"btn btn-primary",attrs:{"href":"#"}},[_vm._v("Get Your Account")])])])])
}]

export { render, staticRenderFns }